module.exports = __webpack_public_path__ + "img/xdcj.da3e377e.png";